import { configureStore } from '@reduxjs/toolkit';
import combinedReducer from '../features/questions/questionSlice';
import searchReducer from '../features/search/searchSlice';



export const store = configureStore({
  reducer: {
    questions: combinedReducer,
    searchQuery: searchReducer,
  }
});
